import React from "react";
import LogoutIcon from "@mui/icons-material/Logout";
import { Button } from "@mui/material";
import { useUser } from "../../context/UserContext";
import { updateLogoutTimeStamp } from "../../services/userService";
import {
  AUDITRACEACTIONS,
  COMMONCONSTANTS,
  LOCALSTORAGENAME,
  USERINFO,
} from "../../data/constants";
import useApi from "../../hooks/useApi";
import { useMsal } from "@azure/msal-react";
import "./Logout.scss";
import { useSignalRConnections } from "../../context/SignalRProvider";
import { logAuditTrace } from "../../services/auditNavigationTraceService";
import { getCurrentESTTime } from "../../utils/dateHelper";
import { useNavigate } from "react-router-dom";

export default function Logout() {
  const { executeApi } = useApi();
  const { setUserId, setProfileImage, userId } = useUser();
  const { instance } = useMsal();
  const { stopAllConnections } = useSignalRConnections();
  const navigate = useNavigate();
  const handleLogout = async () => {
    setTimeout(async () => {
      let isAzureLoggedin = localStorage.getItem(LOCALSTORAGENAME.ISAZURELOGGEDIN);
      if (isAzureLoggedin === COMMONCONSTANTS.TRUE_VALUE) {
        const account = instance.getActiveAccount();
        await instance.logoutPopup({ account });
      }
      logoutOperation();
    }, 100);
  };

  const logoutOperation = async () => {
    await updateLogoutTime();
    await stopAllConnections();

    onClearLocalStorage();

    localStorage.setItem(LOCALSTORAGENAME.ISAZURELOGGEDIN, COMMONCONSTANTS.FALSE_VALUE);
    localStorage.setItem(LOCALSTORAGENAME.LOGOUTEVENT, Date.now().toString());
    setUserId(0);
    setProfileImage(null);
    navigate("/signin", { state: { fromLogout: true } });
  };
  const onClearLocalStorage = () => {
    localStorage.clear();
  };
  const updateLogoutTime = async () => {
    const sessionValue = localStorage.getItem(USERINFO.SESSIONVALUE);
    await executeApi<string, boolean>(updateLogoutTimeStamp, sessionValue);
    logAuditTrace(
      {
        userId: userId,
        objectType: AUDITRACEACTIONS.Logout,
        objectId: userId,
        objectName: "User Id " + userId,
        action: AUDITRACEACTIONS.Logout,
        navigationDateTime: getCurrentESTTime(),
      },
      null,
      true,
    );
  };

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    <div className="logout-btn-wrap" onClick={(e) => e.stopPropagation()}>
      <Button
        fullWidth
        variant="contained"
        onClick={() => handleLogout()}
        className="logout-btn-padding"
        color="error"
        size="small"
      >
        Logout <LogoutIcon fontSize="small" className="logout-icon" />
      </Button>
    </div>
  );
}
